module.exports = __webpack_public_path__ + "first-10-paper.jpg?14a5593442297b69933db33cb35090c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10-paper.jpg
// module id = 404
// module chunks = 0